export default "__VITE_ASSET__wdjmelib__"